module.exports = __webpack_public_path__ + "img/changeApple.a233c8c7.svg";